import React, { useState, useEffect } from 'react';
import { getIndonesianTv } from '../services/tmdbService';
import SectionHeader from './SectionHeader';
import MediaGridCard from './MediaGridCard';
import Pagination from './Pagination';
import LoadingSpinner from './LoadingSpinner';
import '../styles/main.css';

const IndonesianTv = () => {
  const [indonesianTv, setIndonesianTv] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchIndonesian = async () => {
      setLoading(true);

      try {
        setIndonesianTv(
          await getIndonesianTv(currentPage)
        );
      } catch (error) {
        console.error(
          'Error fetching Indonesian TV:',
          error
        );
      } finally {
        setLoading(false);
      }
    };

    fetchIndonesian();
  }, [currentPage]);

  const handlePageChange = (direction) => {
    setCurrentPage((prev) =>
      direction === 'next'
        ? prev + 1
        : Math.max(prev - 1, 1)
    );
  };

  return (
    <section
      className="content-section"
      id="indonesiantv"
    >
      <SectionHeader
        title="Indonesian TV Shows"
        icon="fi fi-id"
      />

      {loading ? (
        <LoadingSpinner label="Loading Indonesian TV" />
      ) : (
        <div className="media-grid">
          {indonesianTv
            .slice(0, 20)
            .map((indonesian) => (
              <MediaGridCard
                key={indonesian.id}
                item={indonesian}
                linkTo={`/tv/${indonesian.id}`}
                icon="fa-star"
              />
            ))}
        </div>
      )}

      <Pagination
        currentPage={currentPage}
        onPageChange={handlePageChange}
      />
    </section>
  );
};

export default IndonesianTv;